const Cards = ({ image, title, desc }) => {
  return (
    <div className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <img src={image} alt={title} className="w-full h-64 object-cover" />

      <div className="p-6 text-center">
        <h3 className="text-2xl font-bold mb-2 text-gray-800">{title}</h3>
        <p className="text-gray-600">{desc}</p>
      </div>
    </div>
  );
};

export default Cards;
